export const translations = {
  de: {
    'nav.home': 'Startseite',
    'nav.about': 'Über mich',
    'nav.projects': 'Projekte',
    'nav.contact': 'Kontakt',
    'nav.colophon': 'Tech-Corner',
    'footer.copyright': `© ${new Date().getFullYear()} Matthias Bauer. Alle Rechte vorbehalten.`,
    'language.german': 'Deutsch',
    'language.english': 'Englisch',
    
    // Home Page
    'home.title': 'Hallo, ich bin Matthias Bauer',
    'home.subtitle': 'Softwareentwickler',
    'home.description': 'Ich erschaffe außergewöhnliche digitale Erlebnisse – mit modernen, responsiven Webanwendungen, die Design und Funktion perfekt verbinden.',
    'home.viewWork': 'Meine Arbeit ansehen',
    'home.contactMe': 'Kontakt aufnehmen',
    
    // About Page
    'about.title': 'Über mich',
    'about.intro': 'Hallo! Ich bin Matthias und schon seit meinen ersten Programmierschritten auf dem Commodore Plus/4 begeistert von Softwareentwicklung. Über die Zeit habe ich auf PCs in Turbo Pascal und Borland Delphi experimentiert und während meines Medieninformatik-Studiums meine Skills in C, C++ und Java vertieft. Gegen Ende meines Studiums habe ich dann meine Leidenschaft für das Web entdeckt – HTML, PHP und JavaScript wurden zu meinen Werkzeugen, um interaktive Webanwendungen zu bauen. Heute liebe ich es, kreative Ideen in funktionierende Software zu verwandeln und spannende Projekte umzusetzen.',
    'about.specialization': 'Ich spezialisiere mich auf die Entwicklung außergewöhnlicher digitaler Erlebnisse mit modernen Webtechnologien. Mein Ziel ist es, effiziente, skalierbare und benutzerfreundliche Anwendungen zu erstellen, die reale Probleme lösen.',
    'about.hobbies': 'Wenn ich nicht programmiere, findest du mich oft dabei, wie ich neue Technologien erkunde, an eigenen Projekten arbeite - auch außerhalb der Softwareentwicklung - oder die Natur genieße.',
    'about.downloadCv': 'Lebenslauf herunterladen',
    'about.showCv': 'Lebenslauf anzeigen',
    'about.viewFullCv': 'Karriereverlauf anzeigen',
    'about.hideFullCv': 'Ausblenden',
    'about.skills': 'Fähigkeiten & Kompetenzen',
    'about.skills.backEnd': 'Backend',
    'about.skills.frontEnd': 'Frontend',
    'about.skills.tools': 'Tools',
    'about.skills.other': 'Andere',
    'about.ct.title': 'Karriereverlauf',
    'about.ct.filter.all': '⭐ Alle',
    'about.ct.filter.job': '🧑‍💻 Berufserfahrung',
    'about.ct.filter.training': '🎓 Ausbildung',
    'about.ct.today': 'Heute',
    'about.ct.noData': 'Keine Einträge für diesen Bereich vorhanden.',

    // Career Timeline
    "2023 – heute": "2023 – Heute",
    
    
    // CV Section
    'cv.experience': 'Berufserfahrung',
    'cv.education': 'Ausbildung',
    'cv.languages': 'Sprachen',
    'about.hideCv': 'Lebenslauf ausblenden',
    
    // Projects Page
    'projects.title': 'Meine Projekte',
    'projects.subtitle': 'Eine Auswahl meiner Arbeiten',
    
    // Contact Page
    'contact.title': 'Kontakt',
    'contact.subtitle': 'Lass uns in Kontakt treten',
    'contact.workTogether': 'Lass uns zusammenarbeiten',
    'contact.description': 'Hast du Fragen oder ein Projekt, an dem wir gemeinsam arbeiten können? Schick mir eine Nachricht und ich melde mich schnellstmöglich bei dir zurück!',
    'contact.name': 'Name',
    'contact.email': 'E-Mail',
    'contact.message': 'Nachricht',
    'contact.send': 'Nachricht senden',
    'contact.form.name': 'Name',
    'contact.form.placeholders.name': 'Dein Name',
    'contact.form.email': 'E-Mail',
    'contact.form.placeholders.email': 'deine@email.de',
    'contact.form.message': 'Nachricht',
    'contact.form.placeholders.message': 'Wie kann ich dir helfen?',
    'contact.form.submit': 'Nachricht senden',
    'contact.form.recaptchaNotice': 'Diese Seite ist durch reCAPTCHA geschützt. Es gelten die',
    'contact.form.privacyPolicy': 'Datenschutzerklärung',
    'contact.form.and': 'und',
    'contact.form.termsOfService': 'Nutzungsbedingungen',
    'contact.form.ofGoogle': 'von Google.',
    'contact.social': 'Oder finde mich auf',
    'contact.success': 'Vielen Dank für deine Nachricht! Ich melde mich bald bei dir.',
    'contact.error': 'Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.',
    'contact.form.messages.recaptchaLoading': 'reCAPTCHA wird geladen...',
    'contact.form.messages.requiredFields': 'Bitte fülle alle Pflichtfelder aus.',
    'contact.form.messages.invalidEmail': 'Bitte gib eine gültige E-Mail-Adresse ein.',
    'contact.form.messages.success': 'Vielen Dank für deine Nachricht! Ich melde mich bald bei dir.',
    
    // Footer
    'footer.privacy': 'Datenschutz',
    'footer.impressum': 'Impressum',
    
    // Impressum
    'impressum.title': 'Impressum',
    'impressum.close': 'Schließen',
    'impressum.legalNotice': 'Angaben gemäß § 5 TMG',
    'impressum.contact': 'Kontakt',
    'impressum.responsible': 'Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV',
    'impressum.disclaimer': 'Haftung für Inhalte',
    'impressum.disclaimerText': 'Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.',
    'impressum.liability': 'Haftung für Links',
    'impressum.liabilityText': 'Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.',
    'impressum.copyright': 'Urheberrecht',
    'impressum.copyrightText': 'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.',
    
    // 404 Page
    'notFound.title': 'Seite nicht gefunden',
    'notFound.message': 'Die angeforderte Seite existiert nicht oder wurde verschoben.',
    'notFound.home': 'Zurück zur Startseite',
    
    // Colophon
    'colophon.title': 'Tech-Corner',
    'colophon.about.title': 'Über diese Website',
    'colophon.about.content': 'Diese Website wurde mit modernen Webtechnologien erstellt, um eine schnelle, barrierefreie und benutzerfreundliche Erfahrung zu bieten. Der Quellcode ist auf GitHub verfügbar.',
    'colophon.technologies.title': 'Verwendete Technologien',
    'colophon.typography.title': 'Typografie',
    'colophon.typography.primary': 'Primärschriftart',
    'colophon.typography.primaryValue': 'Inter (Systemschriftarten-Stack)',
    'colophon.typography.code': 'Code-Schriftart',
    'colophon.typography.codeValue': 'Fira Code (für Code-Snippets)',
    'colophon.colors.title': 'Farben',
    'colophon.colors.primary': 'Primärfarbe',
    'colophon.colors.background': 'Hintergrund',
    'colophon.colors.card': 'Karten',
    'colophon.colors.success': 'Erfolg',
    'colophon.performance.title': 'Performance',
    'colophon.performance.items.0': 'Lazy Loading für Bilder und Komponenten',
    'colophon.performance.items.1': 'Optimierte Assets und Bilder',
    'colophon.performance.items.2': 'Code-Splitting und Tree Shaking',
    'colophon.performance.items.3': 'Dynamisches Laden von nicht-kritischem JavaScript',
    'colophon.accessibility.title': 'Barrierefreiheit',
    'colophon.accessibility.items.0': 'Vollständige Tastaturnavigation',
    'colophon.accessibility.items.1': 'Hoher Kontrast für bessere Lesbarkeit',
    'colophon.accessibility.items.2': 'Semantisches HTML5',
    'colophon.accessibility.items.3': 'ARIA-Labels für verbesserte Screenreader-Unterstützung',
    'colophon.license.title': 'Lizenz',
    'colophon.license.content': 'Der Quellcode dieser Website ist lizenziert unter der MIT-Lizenz. Die Inhalte sind urheberrechtlich geschützt.'
  },
  en: {
    'nav.home': 'Home',
    'nav.about': 'About',
    'nav.projects': 'Projects',
    'nav.contact': 'Contact',
    'nav.colophon': 'Colophon',
    'footer.copyright': `© ${new Date().getFullYear()} Matthias Bauer. All rights reserved.`,
    'language.german': 'German',
    'language.english': 'English',
    
    // Home Page
    'home.title': "Hi, I'm Matthias Bauer",
    'home.subtitle': 'Software Developer',
    'home.description': 'I create exceptional digital experiences – modern, responsive web applications that perfectly blend design and functionality.',
    'home.viewWork': 'View My Work',
    'home.contactMe': 'Contact Me',
    
    // About Page
    'about.title': 'About Me',
    'about.intro': "Hello! I'm Matthias and I've been passionate about software development since my first programming steps on a Commodore Plus/4. Over time, I experimented with Turbo Pascal and Borland Delphi on PCs, and during my Media Computer Science studies, I deepened my skills in C, C++, and Java. Towards the end of my studies, I discovered my passion for the web – HTML, PHP, and JavaScript became my tools for building interactive web applications. Today, I love turning creative ideas into working software and implementing exciting projects.",
    'about.specialization': 'I specialize in building exceptional digital experiences using modern web technologies. My goal is to create efficient, scalable, and user-friendly applications that solve real-world problems.',
    'about.hobbies': 'When I\'m not programming, you\'ll often find me exploring new technologies, working on personal projects—even beyond software development—or enjoying the outdoors.',
    'about.downloadCv': 'Download CV',
    'about.showCv': 'Show CV',
    'about.viewFullCv': 'Show Career Timeline',
    'about.hideFullCv': 'Hide',
    'about.skills': 'Skills & Expertise',
    'about.skills.backEnd': 'Backend',
    'about.skills.frontEnd': 'Frontend',
    'about.skills.tools': 'Tools',
    'about.skills.other': 'Other',
    'about.ct.title': 'Career Timeline',
    'about.ct.filter.all': '⭐ All',
    'about.ct.filter.job': '🧑‍💻 Job',
    'about.ct.filter.training': '🎓 Training',
    'about.ct.today': 'Today',
    'about.ct.noData': 'No entries for this area.',


    "01/2008 – Heute": "01/2008 – today",
    "Fullstack Softwareentwickler": "Fullstack Software Developer",
    "W&S Epic GmbH · Berlin": "W&S Epic GmbH · Berlin",
    "Entwicklung von Schnittstellen nach Kundenanforderungen, Anforderungsanalyse und Softwarekonzeption in enger Zusammenarbeit mit Kunden, Entwicklung individueller Software zur Automatisierung interner Prozesse, Planung und Entwicklung webbasierter Backendsysteme für Kundenprojekte, Konzeption und Entwicklung von Plugins für Shopware- und WordPress-Systeme, Administration und Betreuung von Serverinfrastrukturen": "Development of interfaces according to customer requirements, requirements analysis and software concept development in close collaboration with customers, development of individual software for automating internal processes, planning and development of web-based backend systems for customer projects, concept development and development of plugins for Shopware and WordPress systems, server infrastructure management and maintenance",
    
    "Freiberuflicher Webentwickler": "Freelance Web Developer",
    "Selbstständig · Remote": "Self-employed · Remote",
    "Entwicklung und Programmierung diverser kleinerer Web-Projekte nach Kundenanforderungen": "Development and programming of smaller web projects according to customer requirements",

    "Web-Developer": "Web-Developer",
    "Winkler & Stenzel GmbH · Burgwedel": "Winkler & Stenzel GmbH · Burgwedel",
    "Entwicklung und Programmierung einer Webseite mit integriertem Shop und Content Management System und kleinerer Web-Projekte": "Development and programming of a website with an integrated shop and content management system, as well as smaller web projects",

    "Wissenschaftliche Hilfskraft": "Research Assistant",
    "Hochschule Anhalt (FH) · Köthen/Anhalt, Dessau": "Anhalt University of Applied Sciences · Köthen/Anhalt, Dessau",
    "Unterstützung bei der Weiterentwicklung des Backend der Design-Datenbank Prometheus": "Contributed to the further development of the backend of the design database Prometheus",

    "Studium der Medienfnformatik": "Degree in Media Computer Science (FH)",
    "Hochschule Anhalt (FH) · Köthen/Anhalt" : "Anhalt University of Applied Sciences · Köthen/Anhalt",
    "Grundlagen der objektorientierten Programmierung, Softwarearchitektur und Datenbanken, Einführung in Medientechnik und Computergrafik": "Fundamentals of object-oriented programming, software architecture, and databases; introduction to media technology and computer graphics",
    


    
    // CV Section
    'cv.experience': 'Work Experience',
    'cv.education': 'Education',
    'cv.languages': 'Languages',
    'about.hideCv': 'Hide CV',
    
    // Projects Page
    'projects.title': 'My Projects',
    'projects.subtitle': 'A selection of my work',
    
    // Contact Page
    'contact.title': 'Contact',
    'contact.subtitle': 'Get in touch',
    'contact.workTogether': 'Let\'s work together',
    'contact.description': 'Have a question or a project we can work on together? Send me a message and I\'ll get back to you as soon as possible!',
    'contact.name': 'Name',
    'contact.email': 'Email',
    'contact.message': 'Message',
    'contact.send': 'Send Message',
    'contact.form.name': 'Name',
    'contact.form.placeholders.name': 'Your name',
    'contact.form.email': 'Email',
    'contact.form.placeholders.email': 'your@email.com',
    'contact.form.message': 'Message',
    'contact.form.placeholders.message': 'How can I help you?',
    'contact.form.submit': 'Send Message',
    'contact.form.recaptchaNotice': 'This site is protected by reCAPTCHA and the Google',
    'contact.form.privacyPolicy': 'Privacy Policy',
    'contact.form.and': 'and',
    'contact.form.termsOfService': 'Terms of Service',
    'contact.form.ofGoogle': '',
    'contact.social': 'Or find me on',
    'contact.success': 'Thank you for your message! I will get back to you soon.',
    'contact.error': 'An error occurred. Please try again later.',
    'contact.form.messages.recaptchaLoading': 'reCAPTCHA is loading...',
    'contact.form.messages.requiredFields': 'Please fill in all required fields.',
    'contact.form.messages.invalidEmail': 'Please enter a valid email address.',
    'contact.form.messages.success': 'Thank you for your message! I will get back to you soon.',
    
    // Footer
    'footer.impressum': 'Legal Notice',
    'footer.privacy': 'Privacy Policy',
    
    // Impressum
    'impressum.title': 'Legal Notice',
    'impressum.close': 'Close',
    'impressum.legalNotice': 'Legal Notice according to § 5 TMG',
    'impressum.contact': 'Contact',
    'impressum.responsible': 'Responsible for content according to § 55(2) RStV',
    'impressum.disclaimer': 'Liability for Content',
    'impressum.disclaimerText': 'As a service provider, we are responsible for our own content on these pages under general law according to Section 7 (1) of the German Telemedia Act (TMG). According to §§ 8 to 10 TMG, however, we as a service provider are not obliged to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity.',
    'impressum.liability': 'Liability for Links',
    'impressum.liabilityText': 'Our offer contains links to external websites of third parties, on whose contents we have no influence. Therefore, we cannot assume any liability for these external contents. The respective provider or operator of the pages is always responsible for the content of the linked pages.',
    'impressum.copyright': 'Copyright',
    'impressum.copyrightText': 'The contents and works on these pages created by the site operators are subject to German copyright law. The reproduction, processing, distribution, and any kind of exploitation outside the limits of copyright require the written consent of the respective author or creator.',
    
    // 404 Page
    'notFound.title': 'Page Not Found',
    'notFound.message': 'The requested page does not exist or has been moved.',
    'notFound.home': 'Back to Home',
    
    // Colophon
    'colophon.title': 'Colophon',
    'colophon.about.title': 'About This Website',
    'colophon.about.content': 'This website was built with modern web technologies to provide a fast, accessible, and user-friendly experience. The source code is available on GitHub.',
    'colophon.technologies.title': 'Technologies Used',
    'colophon.typography.title': 'Typography',
    'colophon.typography.primary': 'Primary Font',
    'colophon.typography.primaryValue': 'Inter (System Font Stack)',
    'colophon.typography.code': 'Code Font',
    'colophon.typography.codeValue': 'Fira Code (for code snippets)',
    'colophon.colors.title': 'Color Scheme',
    'colophon.colors.primary': 'Primary',
    'colophon.colors.background': 'Background',
    'colophon.colors.card': 'Card',
    'colophon.colors.success': 'Success',
    'colophon.performance.title': 'Performance',
    'colophon.performance.items.0': 'Lazy loading for images and components',
    'colophon.performance.items.1': 'Optimized assets and images',
    'colophon.performance.items.2': 'Code splitting and tree shaking',
    'colophon.performance.items.3': 'Dynamic loading of non-critical JavaScript',
    'colophon.accessibility.title': 'Accessibility',
    'colophon.accessibility.items.0': 'Full keyboard navigation',
    'colophon.accessibility.items.1': 'High contrast for better readability',
    'colophon.accessibility.items.2': 'Semantic HTML5',
    'colophon.accessibility.items.3': 'ARIA labels for improved screen reader support',
    'colophon.license.title': 'License',
    'colophon.license.content': 'The source code of this website is licensed under the MIT License. The content is copyrighted.'
  }
} as const;